import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { PalletData } from '../apis/pallet.api'
import palletService from '../services/pallet.service'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableVertical, {
  TableVerticalHeader
} from '../components/TableVertical'
import CardButton from '../components/CardButton'

interface InventoryTableProps {
  pallet: PalletData | null
}

export default class InventoryTable extends Component<InventoryTableProps> {
  get headers (): TableVerticalHeader[] {
    const { pallet } = this.props
    if (!pallet || !pallet.inventory) return []
    const { inventoriableType } = pallet.inventory
    const inventoriableHeading = (inventoriableType === 'workOrder')
      ? 'Work order'
      : 'Purchase order'
    return [
      { heading: i18n("Item code"), path: 'inventory.item.code' },
      { heading: inventoriableHeading, path: 'inventory.inventoriable.code' },
      { heading: i18n("QR code"), path: 'code' },
      { heading: i18n("Item description"), path: 'inventory.item.description' },
      { heading: i18n("Quantity"), path: 'quantity' },
      { heading: i18n("Cases per pallet"), path: 'inventory.item.cpp' },
      { heading: i18n("Quantity per case"), path: 'inventory.item.qpc' },
      { heading: i18n("Pallet"), path: 'number' },
      { heading: i18n("Location"), path: 'aliveTransfer.location.name' },
      { heading: i18n("Transfer site"), path: 'aliveTransfer.location.site.name' },
      { heading: i18n("Bin"), path: 'aliveTransfer.bin' },
      { heading: i18n("Device IP address"), path: 'aliveTransfer.ip' },
      { heading: i18n("Reference"), path: 'inventory.note' },
      { heading: i18n("Site LPN"), path: 'attachedLicensePlates.sites' },
      { heading: i18n("Customer LPNs"), path: 'attachedLicensePlates.customers' },
      { heading: i18n("Customer site LPNs"),
        path: 'attachedLicensePlates.customerSites'
      },
      { heading: i18n("Created at"),
        path: 'inventory.createdAt',
        date: true,
        tooltip: 'inventory.createdUser.username'
      },
      { heading: i18n("SKU"), path: 'inventory.sku' },
      { heading: i18n("Product Id"), path: 'inventory.productId' },
      { heading: i18n("Batch/Lot Number"), path: 'inventory.batchLotNumber' },
      { heading: i18n("Bill of Lading"), path: 'inventory.billOfLading' },
      { heading: i18n("Notes"), path: 'inventory.notes' }
    ]
  }

  get pallet () {
    const { pallet } = this.props
    return pallet && palletService.tableVerticalData(pallet)
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("View Inventory")}
          doc='inventories-view-inventory' />
        <TableVertical
          headers={this.headers}
          data={this.pallet} />
        <CardButton cancelText={i18n("Back")} />
      </Card>
    )
  }
}
